'use client';

import { useEffect } from 'react';
import { urlParameterCodes } from '@/constants/urlParams';
import useCartStore from '@/ui/store/cart/cartStore';

export function useReferralCodeCapture() {
  const setReferralVoucherCode = useCartStore((state) => state.setReferralVoucherCode);

  useEffect(() => {
    const code = new URL(globalThis.location.href).searchParams.get(
      urlParameterCodes.referralCode,
    );

    if (!code) {
      return;
    }

    setReferralVoucherCode(code);
  }, [setReferralVoucherCode]);
}
